import { min } from 'lib/array/arrayUtils'
import type { BundleOfferPackageOptionView } from 'selectors/offerPage/bundledOfferPageSelectors'

export function getBundleSummaryPackageView(
  packageOptions: Record<string, BundleOfferPackageOptionView>,
): BundleOfferPackageOptionView {
  const options = Object.values(packageOptions)
  const cheapestAvailableOption = min(options.filter(option => option.capacityValid && option.hotelAvailable), option => option.hotelPrice)
  // Summary callers retain the first option when none is available for this occupancy.
  return cheapestAvailableOption ?? options[0]
}
